import { useState, useEffect } from "react";
import { getFileByIdAPI } from "../api/userApi";

export default function useMedia(imagePath: string | null | undefined) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!imagePath) {
      setImageUrl(null);
      return;
    }

    // Якщо це Google URL (lh3.googleusercontent.com), використовуємо його напряму
    if (imagePath.includes("lh3.googleusercontent.com")) {
      setImageUrl(imagePath);
      setLoading(false);
      setError(null);
      return;
    }

    // Якщо це пряме посилання (https:// або http://), використовуємо його напряму
    if (imagePath.startsWith("https://") || imagePath.startsWith("http://")) {
      setImageUrl(imagePath);
      setLoading(false);
      setError(null);
      return;
    }

    // Extract file ID from image path
    const fileId = imagePath.split("/api/files/")[1];
    if (!fileId) {
      setError("Invalid image path format");
      return;
    }

    setLoading(true);
    setError(null);

    getFileByIdAPI(fileId)
      .then(url => {
        setImageUrl(url);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching image:", err);
        setError(err?.message || "Failed to load image");
        setLoading(false);
      });
  }, [imagePath]);

  return {
    imageUrl,
    loading,
    error,
  };
}
